import React, { useState, useEffect } from "react";
import { auth } from "../Firebase";
import { Navigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useAuth } from "./Context/AuthContext";

const Login = () => {
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      // console.log(userCredential);

      let user = userCredential.user;
      setUser(user);
      setLogin(true);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password);
  };

  if (isLogin) {
    return <Navigate to="/" />;
  }

  return (
    <div className="authentication-container">
      <div className="login-page">
        <h2>Login</h2>
        <form className="authentication-form" onSubmit={handleSubmit}>
          <label>
            Email:
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            Password:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <br />
          <button type="submit" className="authentication-btn">
            Login
          </button>
        </form>
        {/* <p>or</p> */}
        {/* <button onClick={handleGoogleLogin}>Login with Google</button> */}
        <p>
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
};
export default Login;
